/* eslint-disable react/require-default-props */
import Typography from '@mui/material/Typography';
import { Skeleton } from '@mui/material';
import TableContent from './TableContent';
import TableTitle from './TableTitle';
import { Row } from '../../interfaces';
import { HeaderCells, Pagination, Sort } from '../../types/ui';
import './table.css';

interface Props {
  name: string;
  rows: Row[];
  headerCells: HeaderCells;
  emptyMessage: string;
  loading: boolean;
  handleRowClick?: (id: string) => void;
  pagination?: Pagination;
  sort?: Sort;
  small?: boolean;
}

export default function ReuseableTable({
  name,
  rows,
  headerCells,
  emptyMessage,
  loading,
  handleRowClick,
  pagination,
  sort,
  small,
}: Props) {
  return (
    <div className="table">
      <TableTitle
        name={name}
        showing={rows.length}
        total={pagination?.count || rows.length}
        small={small}
      />
      {rows.length > 0 && !loading && (
        <TableContent
          headerCells={headerCells}
          filteredRows={rows}
          handleRowClick={handleRowClick}
          pagination={pagination}
          sort={sort}
          small={small}
        />
      )}
      {!loading && rows.length === 0 && (
        <div className="table-empty">
          <Typography variant="body1">{emptyMessage}</Typography>
        </div>
      )}
      {loading && (
        <div className="table-loading">
          <Skeleton
            variant="rectangular"
            width="100%"
            height={80}
            style={{ marginBottom: 10 }}
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={80}
            style={{ marginBottom: 10 }}
          />
          <Skeleton variant="rectangular" width="100%" height={80} />
        </div>
      )}
    </div>
  );
}
